"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaCodeMapper = void 0;
var AreaCodeMapper = /** @class */ (function () {
    function AreaCodeMapper(data) {
        this.localData = data;
    }
    AreaCodeMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return AreaCodeMapper;
}());
exports.AreaCodeMapper = AreaCodeMapper;
//# sourceMappingURL=AreaCodeMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/AreaCodeMapper.js
// module id = 2057
// module chunks = 8